import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "sticky" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.temp)
      ? (_openBlock(), _createBlock(_component_van_sticky, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/realtime",
                class: "icon-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogShow = true))
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "iconfont icon-back" }, null, -1)
                ])),
                _: 1,
                __: [1]
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}